import React, { useContext, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import StandardDropdown from '../../../Dropdown/Preset/StandardDropdown';
import s from './ThreadOrderSelect.scss';
var ThreadOrderSelect = function (_a) {
    var streamId = _a.streamId, order = _a.order, onOrderChanged = _a.onOrderChanged;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var handleOrderChanged = useCallback(function (value) {
        onOrderChanged && onOrderChanged(streamId, value);
    }, [onOrderChanged, streamId]);
    var items = useMemo(function () { return [
        {
            label: t('commentthread.control.newest'),
            value: 'newest',
        },
        {
            label: t('commentthread.control.oldest'),
            value: 'oldest',
        },
    ]; }, [t]);
    return (React.createElement("div", { className: s['order-select'], "data-hook": BiDataHook.COMMENTS_THREAD_SORTING },
        React.createElement(StandardDropdown, { role: "menu", placement: isMobile ? 'bottom-end' : 'bottom-start', toggleClassName: s['order-select-toggle'], arrowClassName: s['order-select-arrow'], selectedValue: order, items: items, onSelect: handleOrderChanged })));
};
ThreadOrderSelect.displayName = 'ThreadOrderSelect';
export default ThreadOrderSelect;
//# sourceMappingURL=ThreadOrderSelect.js.map